import React, { Component } from 'react'

class Screen6A extends Component {

  render() {

    const { entry, addEntry, language, t } = this.props

    return (
      <main>
        <h3>{t(language, 'hateCrimeDetails')}</h3>
        <label>{t(language, 'why')}&nbsp;
          <input type="text" value={entry.why} onChange={(e) => addEntry('why', null, e)} />
        </label>
        <label>{t(language, 'consequences')}
          <input type="text" value={entry.consequences} onChange={(e) => addEntry('consequences', null, e)} />
        </label>
        <label>{t(language, 'otherNotification')}
          <input type="text" value={entry.other_notification} onChange={(e) => addEntry('other_notification', null, e)} />
        </label>
      </main>
    );
  }
}

export default Screen6A;
